<template>
  <v-list-item dense three-line key="i" class="px-5 SendboxItem" :class="`item-bottom-border`">
    <v-list-item-content>
      <v-list-item-title>
        {{ title }}
      </v-list-item-title>

      <v-list-item-subtitle class="location pb-1">{{ location }}</v-list-item-subtitle>
      <v-list-item-subtitle :class="`subtitle-${themeName}`" class="mb-0">
        <span v-for="(item, index) in text.split('|')" :key="index">
          <span v-if="item.indexOf('<em>') >= 0">
            <v-chip :color="chipColor" class="px-2 mr-1" x-small v-html="item"></v-chip>
          </span>
          <span v-else>{{ item }}&nbsp;</span>
        </span>
      </v-list-item-subtitle>

      <v-list-item-subtitle v-if="sendboxItem.sent" class="mt-0 pt-0">
        <span class="caption">{{ $t('sendbox.sent') }}&nbsp;</span>
        <v-chip :color="chipColor" class="px-2" x-small v-if="sendboxItem.sent">
          {{ renderSentDateTime(sendboxItem.sent) }}
        </v-chip>
      </v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import dateUtils from '@/common/dateUtils';
import common from '@/mixins/common';

export default {
  mixins: [common],
  props: {
    sendboxItem: {
      type: Object,
    },
  },

  methods: {
    renderSentDateTime(sentTimeInMs) {
      return dateUtils.formatAsLocaleDateTime(new Date(sentTimeInMs));
    },
  },
  computed: {
    chipColor(){
      return this.darkMode?'#505050':'#a0a0a0'
    },
    title() {
      return `${this.sendboxItem.title}`;
    },
    location() {
      const i = this.sendboxItem;
      return `${this.$t('module')} ${this.$t(i.module)} ${i.displayLocation ? i.displayLocation : ''}`;
    },

    text() {
      let date = dateUtils.parseISOString(this.sendboxItem.sendboxItem.userdatemodified);
      let actionText = this.$t(this.sendboxItem.actionName);
      let actionDateTime = date ? dateUtils.formatAsLocaleDateTime(date) : 'no date';
      let type = this.$t(`sendbox.type.${this.sendboxItem.objectType}`);

      return this.$t('sendbox.actionText', { type, dateTime: actionDateTime, action: actionText });
    },
  },
};
</script>

<style scoped>
.location {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  font-size: 0.6rem !important;
}

.subtitle-dark,
.subtitle-light {
  line-height: 1.2;
  font-size: 0.75rem !important;
}

.subtitle-dark em,
.subtitle-light em {
  font-style: normal;
}

.border-top-dark {
  border-top: 1px solid #303030;
}

.border-top-light {
  border-top: 1px solid #a0a0a0;
}
</style>
